import { ELEMENT_TYPES, ELEMENT_TYPES_BY_KEY } from 'cg/components/documents/editor/slate/types'
import { Transforms } from 'vendor/slate'
import { v4 as uuidv4 } from 'uuid'

const insertEmbed = (editor, path, type) => {
  const embed = {
    type,
    src: null,
    size: 100,
    aspect: '16by9',
    responsiveEmbedDisabled: ELEMENT_TYPES_BY_KEY[type].responsiveEmbedDisabled || false,
    aspectDisabled: ELEMENT_TYPES_BY_KEY[type].aspectDisabled || false,
    embed_code: ELEMENT_TYPES_BY_KEY[type].embed_code,
    placeholder: ELEMENT_TYPES_BY_KEY[type].placeholder,
    children: [{ uuid: uuidv4(), text: '', parent: { type } }]
  }

  Transforms.insertNodes(editor, embed, { at: path })
}

export { insertEmbed }
